import React from 'react';
import {
  BooleanInput,
  Edit,
  FormTab,
  NumberInput,
  required,
  SelectInput,
  TabbedForm,
  TextInput,
} from 'react-admin';

import { App, NotificationOptionValue } from '../../../graphql/types';
import EditToolbar from '../components/EditToolbar';

export const NotificationOptionEdit: React.FC = () => (
  <Edit mutationMode="pessimistic" redirect={false}>
    <TabbedForm toolbar={<EditToolbar />}>
      <FormTab label="Details">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            width: 400,
          }}
        >
          <TextInput source="id" InputProps={{ disabled: true }} />
          <TextInput source="name" validate={required()} />
          <TextInput source="description" multiline rows={3} />
          <SelectInput
            source="app"
            choices={Object.entries(App).map(([name, value]) => ({
              id: value,
              name: name === 'Heart' ? 'Fit' : 'Perform',
            }))}
            validate={required()}
          />
          <NumberInput source="position" validate={required()} />
          <BooleanInput source="visible" />
          <SelectInput
            source="value"
            choices={Object.entries(NotificationOptionValue).map(
              ([name, value]) => ({
                id: value,
                name,
              }),
            )}
          />
          <TextInput source="featureFlag" label="Feature Flag" />
          <NumberInput source="iterableId" label="Iterable ID" />
        </div>
      </FormTab>
    </TabbedForm>
  </Edit>
);
